import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import LockedField, { LockNotice } from "./LockedField";

const AppointmentSection = ({
  formData,
  formErrors,
  onInputChange,
  // A LOCK_NOTICES key, or null. A sent contract locks date/time/duration
  // because the contract quotes them; the note stays editable.
  lock = null,
  onLockClick,
}) => {
  return (
    <div className="appointment-section">
      <div className="section-title-with-notice">
        <h6 className="section-title">Appointment</h6>
        <LockNotice notice={lock} />
      </div>
      <div className="section-fields">
        <LockedField notice={lock} onLockClick={onLockClick} showNotice={false}>
          <Row className="mb-3">
            <Col md={4}>
              <Form.Group>
                <Form.Label>
                  Date <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="date"
                  value={formData.date}
                  onChange={(e) => onInputChange("date", e.target.value)}
                  isInvalid={!!formErrors.date}
                />
                <Form.Control.Feedback type="invalid">
                  {formErrors.date}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>
                  Time <span className="text-danger">*</span>
                </Form.Label>
                <div className="figma-time-picker">
                  <Form.Control
                    type="time"
                    value={formData.startTime}
                    onChange={(e) => onInputChange("startTime", e.target.value)}
                    isInvalid={!!(formErrors.startTime || formErrors.endTime)}
                    className="time-input"
                  />
                  <span className="time-separator">-</span>
                  <Form.Control
                    type="time"
                    value={formData.endTime}
                    onChange={(e) => onInputChange("endTime", e.target.value)}
                    isInvalid={!!(formErrors.startTime || formErrors.endTime)}
                    className="time-input"
                  />
                </div>
                {(formErrors.startTime || formErrors.endTime) && (
                  <div className="invalid-feedback d-block">
                    {formErrors.startTime || formErrors.endTime}
                  </div>
                )}
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group>
                <Form.Label>
                  Duration <span className="text-danger">*</span>
                </Form.Label>
                <div className="input-group">
                  <Form.Control
                    type="number"
                    min="1"
                    value={formData.duration}
                    onChange={(e) => onInputChange("duration", e.target.value)}
                    isInvalid={!!formErrors.duration}
                  />
                  <span className="input-group-text">min</span>
                </div>
                <Form.Control.Feedback type="invalid">
                  {formErrors.duration}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
        </LockedField>

        <Row className="mb-2">
          <Col md={12}>
            <Form.Group>
              <Form.Label>Note</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={formData.note}
                onChange={(e) => onInputChange("note", e.target.value)}
                isInvalid={!!formErrors.note}
              />
              <Form.Control.Feedback type="invalid">
                {formErrors.note}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default AppointmentSection;
